/* eslint-disable indent,no-use-before-define,no-param-reassign,spaced-comment,arrow-body-style,padded-blocks,no-trailing-spaces,no-multiple-empty-lines,semi,dot-notation,prefer-const,no-unused-vars,prefer-template,keyword-spacing,no-undef,no-empty */
import _ from 'lodash';
import vasActivationModalTemplate from './MerchantInfoModal.html';

class ListaMerchantSuperAdminController {
  /* @ngInject */

  constructor($log, SuperAdminService, $filter,
              FoundationApi, ModalFactory, $timeout,
              PaginationSettings, StoreService, LoginService, $state,
              $rootScope, StorageService, MerchantVasService,
              MerchantService, VasTypes) {

    const that = this;
    let listaMerchant = undefined;
    let modal = undefined;
    let filteredMerchantList = [];
    let loginModalOpen = false;
    this.loader = false;
    this.loaderUpgrade = false;
    this.minLengthForSearch = 2;
    this.results;

    this.filters = {
      text: '',
      type: 'any',
      typeModel: 'any',
      vas: 'any',
      vasModel: 'any'
    };

    this.retrievedPage = null;

    this.vasMerchantsMap = {};

    this.paginationOption = {};

    this.paginationCursor = {};

    this.vasTypes = VasTypes;
    console.log(this.vasTypes);

    const changePage = (index = 0) => {
      getMerchantStore(index);
      return true;
    };

    const getVasMerchantsMap = (merchants) => {
      let vasByMerchantsMap = {};
      _.forEach(merchants, (merchant) => {
        let vasses = {};
        try {
          _.forEach(merchant.vasses, (vas) => {
            vasses[vas.name] = vas;
          });
          vasByMerchantsMap[merchant.name] = vasses;
        } catch (e) {
          $log.debug('no vas available for merchant with username ' + merchant.username);
        }
      });
      return vasByMerchantsMap;
    };

    that.isVasActive = (vasType, merchantUsername) => {

      let isActive = false;

      try {
        isActive = that.vasMerchantsMap[merchantUsername][vasType]['status'] === 'SUBSCRIBED';
      } catch (e) {

      }

      return isActive;

    };

    const processMerchant = (listMerchant) => _.forEach(listMerchant, (merchant) => {
      const newRecord = merchant;

      if (merchant.vasEnabledList !== undefined) {
        newRecord.tinabaFast = _.includes(merchant.vasEnabledList, 'CHECK-IN=1');
        newRecord.tinabaOrder = _.includes(merchant.vasEnabledList, 'ORDER-AND-PAY=1');
        newRecord.tinabaOutbound = _.includes(merchant.vasEnabledList, 'OUTBOUND=1');
        newRecord.tinabaOrderAtTable = _.includes(merchant.vasEnabledList, 'ORDER-AT-TABLE=1');
        newRecord.tinabaOrderAndPick = _.includes(merchant.vasEnabledList, 'ORDER-AND-PICK=1');
        newRecord.tinabaOrderAndDelivery = _.includes(merchant.vasEnabledList, 'ORDER-AND-DELIVERY=1');
        newRecord.tinabaOfficeDelivery = _.includes(merchant.vasEnabledList, 'OFFICE-DELIVERY=1');
      }

      newRecord.loader = false;
      return newRecord;
    });

    const getMerchantStore = (pageIndex = 0) => {
      that.loader = true;

      let stringInAlias = this.filters.text !== '' ? this.filters.text : undefined;
      let typeVas = this.filters.vas === 'any' ? undefined : this.filters.vas;
      //let typeMerchant = this.filters.type === 'any' ? "business" : this.filters.type;
      var typeMerchant = undefined
      if(this.filters.type !== 'any') {
        typeMerchant = this.filters.type === 'BIZ' ? 'business' : this.filters.type;
      }

      MerchantService.getMerchants(pageIndex, that.paginationOptions.pageButtonsToShow, stringInAlias, typeVas, typeMerchant).then((ok) => {
          //that.pagination.currentPage.data = ok.data['_embedded'];
          that.retrievedPage = ok.data.hasOwnProperty('_embedded') ? ok.data['_embedded'].businesses : [];
          if (that.setCurrentPageIndex) {
            that.setCurrentPageIndex(ok.data['page']['number']);
          }
          
          that.setPagesNumber(ok.data['page']['totalPages']);
          that.vasMerchantsMap = getVasMerchantsMap(that.retrievedPage);
          that.loader = false;
        }, (e) => {
          $log.debug(e);
          that.loader = false;
        }
      );
    };

    const closeModal = () => {
      if (!loginModalOpen) return;
      modal.deactivate();
      loginModalOpen = false;
      $timeout(() => {
        modal.destroy();
      }, 1000);
      getMerchantStore();
    };

    const openLoginSuperAdminModal = () => {
      if (loginModalOpen) return;
      if (MODE != "admin") {
        $state.go('dashboard');
        return;
      }
      loginModalOpen = true;

      FoundationApi.closeActiveElements();

      modal = new ModalFactory({
        class: 'tiny',
        overlay: true,
        overlayClose: false,
        template: '<login-super-admin on-login-completed="close()"></login-super-admin>',
        contentScope: {
          close: () => closeModal()
        }
      });

      modal.activate();
    };


    this.getLabelVas = () => {
      switch (this.filters.vas) {
        case 'any':
          return 'TUTTI';
        case VasTypes.PICK:
          return 'TAKE AWAY';
        case VasTypes.TABLE:
          return 'ORDINA AL TAVOLO';
        case VasTypes.ORDER_AND_PAY:
          return 'ACQUISTA IN NEGOZIO';
        case VasTypes.PROMO_OUTBOUND:
          return 'KNOW YOUR CLIENT';
        case VasTypes.DELIVERY:
          return 'CONSEGNA A DOMICILIO';
        case VasTypes.OFFICE_DELIVERY:
          return 'CONSEGNA IN UFFICIO';
        case VasTypes.CHECKIN:
          return 'CONTO AL TAVOLO';
        case VasTypes.INVOICES:
          return 'FATTURAZIONE';
        case VasTypes.CORPORATE_CASH:
          return 'CASSA AZIENDA';
        case VasTypes.PAY_WITH_ALIPAY:
            return 'PAGAMENTI CON ALIPAY';
        case VasTypes.PROJECT_WITH_ALIPAY:
          return 'DONAZIONI CON ALIPAY';
        case VasTypes.MOBILE_PAY_WITH_ALIPAY:
          return 'P2P CON ALIPAY';
        case VasTypes['ONLINE-PAY-WITH-CONNECT']:
          return 'ALIPAY ONLINE'
      }
    };

    that.makeMerchantInfoModal = (merchantUsername) => {
      const closeMerchantInfoModal = () => {
        merchantInfoModal.deactivate();
        $timeout(merchantInfoModal.destroy, 1000);
      };

      let vasTypes = [
        'ORDER-AND-PAY',
        'ORDER-AND-PICK',
        'ORDER-AND-DELIVERY',
        'OFFICE-DELIVERY',
        'ORDER-AT-TABLE',
        'BILL-AT-TABLE',
        'OUTBOUND-MESSAGES',
        'INVOICES',
        'CORPORATE-CASH',
        'PAY-WITH-ALIPAY',
        'PROJECT-WITH-ALIPAY',
        'MOBILE-PAY-WITH-ALIPAY',
        'ONLINE-PAY-WITH-CONNECT'
      ];

      let modalInfoObject = {};

      _.forEach(vasTypes,
        (vasName) => {

          modalInfoObject[vasName] = {
            isActive: that.isVasActive(vasName, merchantUsername),
            activationTimestamp: that.isVasActive(vasName, merchantUsername) ? that.vasMerchantsMap[merchantUsername][vasName].subscriptionDate : undefined,
            deactivationTimestamp: 0
          };

        }
      );

      let merchantInfoModal = new ModalFactory({
        class: 'default',
        overlay: true,
        overlayClose: false,
        template: vasActivationModalTemplate,
        contentScope: {
          close: () => closeMerchantInfoModal(),
          vasMap: modalInfoObject
        }
      });

      merchantInfoModal.activate();


    };

    that.onSearch = () => {
      $log.log(that.filters.text);
      getMerchantStore(0);
    };

    this.resetFilters = () => {
      this.filters.type = 'any';
      this.filters.vas = 'any';
      this.filters.typeModel = 'any';
      this.filters.vasModel = 'any';
      getMerchantStore(0);
      // that.filters.typeLabel = 'Tutti';
      // that.filters.vasLabel = 'Tutti';
      // loadMovements();
    };

    that.applyFilters = () => {
      this.filters.type = this.filters.typeModel;
      this.filters.vas = this.filters.vasModel;
      getMerchantStore(0);
    };

    that.makeUpgrade = (merchant) => {
      if (that.loaderUpgrade) return;
      that.loaderUpgrade = true;
      merchant.loader = true;
      LoginService.superAdminUpgrade(merchant).then(() => {
        that.loaderUpgrade = false;
        merchant.loader = false;
        $log.debug('Upgrade effettuato con successo');
        $state.go('dashboard');
        $rootScope.$broadcast('SUPER_ADMIN_UPGRADED');
      }, (error) => {
        that.loaderUpgrade = false;
        merchant.loader = false;
        $log.error(error);
      });
    };

    const init = () => {
      StoreService.clean();
      //that.pagination.pageSize = that.isCondensed ? PaginationSettings.CONDENSED_PAGE_SIZE : PaginationSettings.DEFAULT_PAGE_SIZE;
      this.pageChangedCallback = (index = 0) => {
        changePage(index);
      };
     
      this.paginationOptions = {
        pageButtonsToShow: 5
      };
      this.paginationCursor = {
        totalPages: 0,
        selectedPageIndex: 0
      };

      if(StorageService.getLocalStorage('superAdmin') !== 'true') {
        openLoginSuperAdminModal();
        return;
      }

      changePage();

    };
    that.$onInit = init;


    const deregLogin = $rootScope.$on('event:auth-loginRequired', () => {
      openLoginSuperAdminModal();
    });

    const deregSuperLogin = $rootScope.$on('event:auth-superLoginRequired', () => {
      openLoginSuperAdminModal();
    });

    const deregLogoutListener = $rootScope.$on('USER_LOGGED_OUT', () => {
      if (StorageService.getLocalStorage('superAdmin') !== 'true') openLoginSuperAdminModal();
    });

    const deRegStateChangedListener = $rootScope.$on('$stateChangeSuccess', () => {
      closeModal();
    });

    that.$onDestroy = () => {
      deRegStateChangedListener();
      deregLogoutListener();
      deregLogin();
    };

  }
}

export default ListaMerchantSuperAdminController;



/** WEBPACK FOOTER **
 ** ./client/app/components/listaMerchantSuperAdmin/listaMerchantSuperAdmin.controller.js
 **/